<app-info-message />
<div class="background--confirm">
  <section class="form-container">
    @if (errorMessage()) {
      <div class="warn-box-authentication subtitle-1">
        <mat-icon matPrefix>error</mat-icon>
        {{ errorMessage() }}
      </div>
    }
    <mat-toolbar>
      <mat-toolbar-row>
        <img src="../../assets/images/logo.svg" />
        <h5 class="toolbar-title">Online</h5>
      </mat-toolbar-row>
    </mat-toolbar>
    @if (!linkIsExpiredOrInvalid && !pendingCheck) {
      <div class="content-confirm">
        <div class="welcome-text subtitle-1">
          <div>Welcome, {{ name }}</div>
          <div>Please set your new password</div>
        </div>
        <form (ngSubmit)="setPassword()" [formGroup]="setPasswordForm">
          <mat-form-field class="mt-5">
            <mat-label>Username</mat-label>
            <input autocomplete="username" formControlName="username" matInput required />
            @if (username.hasError('required')) {
              <mat-error> Username is <strong>required</strong> </mat-error>
            }
            @if (!username.valid && !username.hasError('required')) {
              <mat-error class="mat-error"> Please enter a valid username </mat-error>
            }
          </mat-form-field>
          <div class="gray-title">
            <div>Your password must include:</div>
            <div>
              <mat-icon [class.green]="!password.hasError('minlength')">{{
                !password.hasError('minlength') ? 'check_circle' : 'radio_button_unchecked'
              }}</mat-icon>
              at least {{ minCharacters }} characters
            </div>
          </div>
          <mat-form-field class="password">
            <mat-label>Password</mat-label>
            <input
              (ngModelChange)="errorMessage.set('')"
              [type]="hidePassword ? 'password' : 'text'"
              autocomplete="new-password"
              formControlName="password"
              matInput />
            <button matIconButton matSuffix type="button" (click)="hidePassword = !hidePassword">
              <mat-icon>{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (password.hasError('minlength')) {
              <mat-error> Must be at least {{ minCharacters }} characters long. </mat-error>
            }
            @if (password.hasError('containUsername')) {
              <mat-error> Password cannot contain your username </mat-error>
            }
          </mat-form-field>
          <mat-form-field>
            <mat-label>Confirm password &nbsp;</mat-label>
            <input
              [type]="hideConfirmPassword ? 'password' : 'text'"
              autocomplete="new-password"
              formControlName="confirmPassword"
              matInput />
            <button matIconButton matSuffix type="button" (click)="hideConfirmPassword = !hideConfirmPassword">
              <mat-icon>{{ hideConfirmPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
            </button>
            @if (confirmPassword.hasError('passwordMismatch')) {
              <mat-error> Your passwords do not match </mat-error>
            }
          </mat-form-field>
          <button
            matButton="elevated"
            class="red-button body-1 mt-5"
            type="submit"
            [disabled]="setPasswordForm.invalid || submitPending()">
            SET PASSWORD
          </button>
        </form>
      </div>
    }

    @if (linkIsExpiredOrInvalid && !pendingCheck) {
      <div class="warn-container">
        <div class="warn-box">
          <mat-icon matPrefix>report_problem</mat-icon>
          <div>This link has expired or has been invalidated.</div>
          <div class="margin-top-20">
            To Receive a new link, please contact your Location's administrator or contact Stelvio Support at
          </div>
          <div>(02) 9455 1055</div>
        </div>
      </div>
    }
  </section>
</div>
<app-static-footer />
